// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lTTl4","col":"styles_col__22aCN"};